import { useGetRewardsUpsellWebApiHandler_getRewardsUpsell } from '@zg-rentals/ts-rent-payment-client-react-query';
import { RewardsApiUserStatus } from '@zg-rentals/ts-rent-payment-client';

/**
 * Hook to fetch combined rewards upsell data.
 *
 * Replaces separate `useRewardsSupport` + `useRewardsUserStatus` calls
 * with a single API request.
 *
 * - `isEnabled`    – whether the rewards program is enabled globally
 * - `isSupported`  – whether the current user is eligible
 * - `isEnrolled`   – whether the user is actively enrolled
 * - `points`       – current point balance
 * - `cardDisplay`  – BE-driven card content (title, description, CTAs)
 * - `isLoading`    – whether the query is still loading
 */
export function useRewardsUpsell() {
  const { data, isLoading } = useGetRewardsUpsellWebApiHandler_getRewardsUpsell();

  const enrollmentBonus = data?.user?.presentation?.bonusOffers?.find(
    (offer) => offer.transactionType === 'ENROLLMENT_BONUS',
  );

  const progressSteps = data?.user?.presentation?.progressSteps ?? [];
  const maxPoints = progressSteps.length > 0 ? progressSteps[progressSteps.length - 1] : 0;

  return {
    isRewardsEnabled: data?.isEnabled ?? false,
    isRewardsSupported: data?.isSupported ?? false,
    isEnrolled: data?.user?.status === RewardsApiUserStatus.ACTIVE,
    points: data?.user?.currentPointBalance ?? 0,
    maxPoints,
    cardDisplay: data?.cardDisplay,
    claimablePoints: enrollmentBonus?.points ?? 0,
    isLoading,
  };
}
